// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF

import React, { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toggleImportDialog } from 'store/reducers/projectSettingsSlice';
import ImportProjectDialogContent from 'components/projectSelection/settings/ImportProjectDialogContent';
import { Dialog } from '@tls/treact-ui';

export default function ImportProjectDialog() {
  const { importDialog } = useAppSelector(s => s.projectSettings);
  const dispatch = useAppDispatch();

  const onClose = useCallback(() => {
    dispatch(toggleImportDialog());
  }, [dispatch]);

  return (
    <Dialog enableClosing open={importDialog} size='large' onClose={onClose} data-testid='projects-import-dialog'>
      <ImportProjectDialogContent saveOnEnter={importDialog} />
    </Dialog>
  );
}
